import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

export const resourcePage = {
  id: "ece-resources",
  department: "Electronics & Communication Engineering",
  short: "E&CE",
  description: "student_resources for the Department of Electronics & Communication Engineering.",
  resourceSet: "ece",
  sections: [
    {
      title: "Syllabus",
      items: [
        {
          label: "VTU Syllabus",
          href: "https://drive.google.com/drive/folders/18CGuoiiLd1iEpPUaObQQUBrqrgrG78p1?usp=drive_link",
        },
      ],
    },
    { title: "Timetable", items: [
        // {
        //   label: "1st Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "2nd Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "3rd Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "4th(A) Semester TimeTable",
          href: "/student_resources/ECE/TimeTable/4th  A Timetable.pdf",
        },
        {
          label: "4th(B) Semester TimeTable",
          href: "/student_resources/ECE/TimeTable/4th B Timatable.jpg",
        },
        // {
        //   label: "5th Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "6th(A) Semester TimeTable",
          href: "/student_resources/ECE/TimeTable/6th A timetable.pdf",
        },
        {
          label: "6th(B) Semester TimeTable",
          href: "/student_resources/ECE/TimeTable/6th B timetable.pdf",
        },
    ] },
    { title: "Academic Calendar", items: [
      {
          label: "COE 4th SEM",
          href: "/student_resources/ECE/COE/COE 4th SEM.pdf",
        },
        {
          label: "COE 6th SEM",
          href: "/student_resources/ECE/COE/COE 6th SEM.pdf",
        },
    ] },
    {
      title: "IA Syllabus",
      items: [
        {
          label: "IA Syllabus",
          href: "https://drive.google.com/file/d/15ufkKwEuL6xx1JhMOzBr7vHba1f5gobQ/view?usp=drive_link",
        },
      ],
    },
    {
      title: "Question Papers & Solutions",
      items: [
        {
          label: "Question Paper and Solution",
          href: "https://drive.google.com/drive/folders/1lqLd0qk51NAIRHKVqxIfPvGQrycxhqi3?usp=drive_link",
        },
      ],
    },
    {
      title: "Add-On Subjects",
      items: [
        {
          label: "Add-On Course Syllabus",
          href: "https://drive.google.com/drive/folders/1XdNFBjFlN0jUIKh3gqWNNLYMIDem4tKC?usp=drive_link",
        },
      ],
    },
    // {
    //   title: "Published Papers & Patents",
    //   items: [
    //     {
    //       label: " INTEGRATED LEGAL CASE ANALYSIS AND DOCUMENT GENERATION SYSTEM USING RETRIEVAL-AUGMENTED AI MODELS ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-396.pdf",
    //     },
    //     {
    //       label: " NETWORK TRAFFIC ANALYSIS FOR SECURITY ANOMALY ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-799.pdf",
    //     },
    //     {
    //       label: " CROWD SENSE: A REAL-TIME SYSTEM FOR CROWD ANALYTICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-883.pdf",
    //     },
    //     {
    //       label: " AI-DRIVEN MOBILE FORENSICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1145.pdf",
    //     },
    //     {
    //       label: " AI-BASED TEXT TO 3D MODEL GENERATOR",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1793-793.pdf",
    //     },
    //   ],
    // },
    {
      title: "Mentor List",
      items: [
        {
          label: "2025-26",
          href: "/student_resources/ECE/MentorMentee/mentor mentee list.pdf",
        },
      ],
    },
  ],
};

const ECEResources = () => <StudentResourceTemplate resourcePage={resourcePage} />;

export default ECEResources;
